var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<ng-transclude ng-transclude-slot=\"initial\"> </ng-transclude> <ng-transclude ng-transclude-slot=\"pending\"> <load-pending> <span style=\"position: relative; top: 0; width: auto\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n<span ng-i18next>common.loading</span> </load-pending> </ng-transclude> <ng-transclude ng-transclude-slot=\"ready\"> <load-ready> {{ value }} </load-ready> </ng-transclude> <ng-transclude ng-transclude-slot=\"error\"> <load-error></load-error> </ng-transclude>";
var id1="load.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/load.html
// module id = 67
// module chunks = 0 2